<template>
	<PageTemplate>
		<template #header>
			<div class="bit nine8 py-4">
				<h1>Projects</h1>
			</div>
		</template>
		<div
			class="bit nine8 space-between"
			:class="[{ normal: normalToggle }]"
		>
			<!-- <div class="window">
			<div class="window-body">
				<div class="options">
					Toggle font:
					<button
						class="btn btn-primary"
						@click="normalToggle = !normalToggle"
					>
						Turn {{ normalToggle ? "on" : "off" }} 8bit font
					</button>
				</div>
			</div>
		</div> -->
			<div class="container flex gap-3">
				<WindowComponent
					><template #title>
						<h2>Web Development</h2>
					</template></WindowComponent
				>

				<WindowComponent>
					<template #title><h2>This Website</h2></template>
					<div class="banner">
						<img
							class="img-fluid"
							src="/assets/projects/news.png"
						/>
					</div>
					<p>Upcoming published works section.</p>
					<p>
						A set of portfolio pages made in Vue.js!
					</p>
					<p>
						In addition to being a place to showcase my photography, music, and projects, the website itself is designed to showcase my abilities as a developer and a designer.
						I wanted to incorporate a variety of styles while maintaining a clear personality and voice.
					</p>
					<div class="banner">
						<img src="/assets/projects/photogrid.png" alt="" class="img-fluid">
					</div>
				</WindowComponent>
			</div>
			<br/>
			<div class="container flex gap-3">
				<WindowComponent>
					<template #title>
						<h2>Game Jams</h2>
					</template>
				</WindowComponent>
				<WindowComponent>
					<template #title>
						<h3>Just Another Human - McGameJam 2026</h3>
					</template>
					<template #default>
						<div class="banner">
							<img
								class="img-fluid"
								src="/assets/project_images/VXcN2R.png"
							/>
						</div>
						<p>
							Blort has breached containment. Blend in, steal back
							your stuff, and outsmart the agent on your neon
							trail. Just a Regular Human was created during the
							2026 edition of the McGameJam (January 30th to
							February 1st) under the theme The Hunt. The game
							incorporates several diversifier challenges,
							including player customization, multiple art styles,
							voice acting provided by another team, and yes… the
							presence of a horse.
						</p>
						<p>Role: Music and Sound Design</p>
					</template>
					<template #footer>
						<a
							href="https://yearlyoccurrence.itch.io/just-a-regular-human"
							>See more here</a
						>
					</template>
				</WindowComponent>
				<WindowComponent>
					<template #title
						><h3>Momentum - Gamebling Game Jam</h3></template
					>
					<template #footer>
						<a href="https://wevwyrm.itch.io/momentum"
							>See more here</a
						>
					</template>
					<img
						class="img-fluid"
						src="/assets/project_images/nMdgZ_.png"
					/>
					<p>
						Betting got a little too serious when you traded your
						life for money. Welcome to Momentum, a lil roulette
						inspired tower defense game...
					</p>
					<p>
						Stop the marbles from reaching your heart by placing
						betting chips around the track! Press the play button to
						let them on the track when you're ready, but be wary...
						for cash and life are one in the same...
					</p>
					<p>Role: Programming, Music</p>
				</WindowComponent>
				<WindowComponent>
					<template #title><h3>Claire de Rune</h3></template>
					<template #footer>
						<a
							href="https://single-cell-studios.itch.io/clair-de-rune"
							>see more</a
						>
					</template>
					<div class="banner">
						<img
							class="img-fluid"
							src="/assets/project_images/claire2.png"
						/>
					</div>
					<p>
						A point-and-click puzzle game where you attempt to
						decipher ancient poems to uncover the right sequences of
						runes, all with the goal of learning a spell to cure
						your little brother's illness.
					</p>
					<p>Role: Music</p>
				</WindowComponent>
			</div>
			<br />
			<div class="container flex gap-3">
				<WindowComponent>
					<template #title>
						<h2>Course Work</h2>
					</template>
				</WindowComponent>

				<WindowComponent>
					<template #title>
						<h3>
							Astrid: Lost City - COMP376 (Introduction to Game
							Development)
						</h3>
					</template>
					<template #footer>
						<a href="/files/Pixel Knights.zip">Download here</a>
					</template>
					<div class="banner">
						<img
							class="img-fluid"
							src="/assets/project_images/Astrid.png"
						/>
					</div>
					<p>Roles: Music, Input Programming, Story Telling</p>
				</WindowComponent>
			</div>

			<!-- <div class="row">
			<div class="tui-window">
				<fieldset class="tui-fieldset">
					<legend class="">McGameJam 2026</legend>
					<img
						class="img-fluid"
						src="/assets/project_images/VXcN2R.png"
					/>
					<p>Role: Music and Sound Design</p>
				</fieldset>
			</div>
			<div class="tui-window">
				<h4>
					<a href="https://wevwyrm.itch.io/momentum"
						>Gamebling Game Jam</a
					>
				</h4>
				<img
					class="img-fluid"
					src="/assets/project_images/nMdgZ_.png"
				/>
				<p>Role: Programming, Music</p>
			</div>

			<div class="tui-window">
				<h4>
					<a href="https://single-cell-studios.itch.io/clair-de-rune"
						>Claire de Rune
					</a>
				</h4>
				<img
					class="img-fluid"
					src="/assets/project_images/claire.jpg"
				/>
				<p>Role: Music</p>
			</div>
		</div>

		<h3>Course Work</h3>
		<div class="row">
			<h4>
				<a href="/files/Pixel Knights.zip"> Astrid: Lost City </a>
			</h4>
			<img class="img-fluid" src="/assets/project_images/Astrid.png" />
			<p>Roles: Music, Character Movement, Story Telling</p>
		</div> -->
		</div>
	</PageTemplate>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";

import projects from "@/data/projects/projects.json";
// import "98.css";
// import projectIcon from '../components/projects/projectIcon.vue';
import ProjectIcon from "@/components/projects/projectIcon.vue";
import WindowComponent from "../components/projects/WindowComponent.vue";
import PageTemplate from "./PageTemplate.vue";
console.log(projects);
// import "xp.css";

const normalToggle = ref(false);
</script>
